import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { Provider } from '@app/models';
import {
  ProviderActionsUnion,
  ProviderActionTypes
} from '@core/actions/provider.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface State extends EntityState<Provider> {
  loading: boolean;
  loaded: boolean;
  creating: boolean;
  ProviderIds: number[];
  Providers: number[];
  Suppliers: number[];
  isBusy: boolean;
  rebates: any[];
}

export const adapter: EntityAdapter<Provider> = createEntityAdapter<Provider>({
  selectId: (provider: Provider) => provider.id
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  creating: false,
  ProviderIds: [],
  Providers: [],
  Suppliers: [],
  isBusy: false,
  rebates: []
});

export function reducer(
  state: State = INITIAL_STATE,
  action: ProviderActionsUnion
) {
  switch (action.type) {
    case ProviderActionTypes.LoadSupplier:
    case ProviderActionTypes.Load:
    case ProviderActionTypes.UpdateManagement:
    case ProviderActionTypes.CreateManagement:
    case ProviderActionTypes.AddResponsable:
    case ProviderActionTypes.DeleteResponsable:
      return { ...state, loading: true, isBusy: true };

    case ProviderActionTypes.LoadFail:
      return { ...state, loading: false };

    case ProviderActionTypes.LoadSuccess:
      return adapter.upsertMany(action.providers, {
        ...state,
        loading: false,
        loaded: true,
        isBusy: false,
        Suppliers: action.providers
      });
      // return {
      //   ...state,
      //   loading: false,
      //   loaded: true,
      //   isBusy: false
      // };
    
    case ProviderActionTypes.ProviderRebateSuccess:
      return {
        ...state,
        rebates: action.data
      }
    
    case ProviderActionTypes.AddResponsableSuccess:
    case ProviderActionTypes.CreateManagementSuccess:
    case ProviderActionTypes.UpdateManagementSuccess:
    case ProviderActionTypes.DeleteResponsableSuccess:
       return adapter.upsertMany(action.data, {
         ...state,
         loading: false,
         loaded: true,
         isBusy: false
       });

    case ProviderActionTypes.AddResponsableFail:
    case ProviderActionTypes.CreateManagementFail:
    case ProviderActionTypes.UpdateManagementFail:
    case ProviderActionTypes.DeleteResponsableFail:
      return {
        ...state,
        loading: false,
        loaded: true,
        isBusy: false
      }

    case ProviderActionTypes.LoadByFollowGroup:
      return { ...state, loading: true, isBusy: true };

    case ProviderActionTypes.LoadByFollowGroupFail:
      return { ...state, loading: false };

    case ProviderActionTypes.LoadByFollowGroupSuccess:
      return adapter.addAll(action.providers, {
        ...state,
        loading: false,
        isBusy: false
      });
    case ProviderActionTypes.Create:
      return { ...state, creating: true };

    case ProviderActionTypes.CreateFail:
    case ProviderActionTypes.CreateSuccess:
      return { ...state, creating: false };

    case ProviderActionTypes.AddAll:
      return adapter.upsertMany(action.providers, {
        ...state,
        loading: false
      });

    case ProviderActionTypes.AddOne:
      return adapter.addOne(action.provider, state);

    case ProviderActionTypes.ProviderUpdate:
      return adapter.updateOne({ id: action.id, changes: action.rut }, state);

    case ProviderActionTypes.Search:
      return {
        ...state,
        Providers: [],
        loading: true
      };

    case ProviderActionTypes.SearchSuccess:
      return {
        ...state,
        Providers: action.ProviderIds.length === 0 ? [] : action.ProviderIds,
        loading: false
      };

    case ProviderActionTypes.SearchFail:
      return {
        ...state,
        Providers: [],
        loading: false
      };

    case ProviderActionTypes.UploadProcessFail:
        return {
          ...state,
          Providers: [],
          loading: false,
          isBusy: false
        };

    case ProviderActionTypes.SearchClear:
      return {
        ...state,
        Providers: [],
        loading: false
      };

    case ProviderActionTypes.SearchPro:
      return {
        ...state,
        ProviderIds: [],
        loading: true
      };

    case ProviderActionTypes.SearchSuccessPro:
      return {
        ...state,
        ProviderIds:
          action.ProviderIds.length === 0 ? [-1] : action.ProviderIds,
        loading: false
      };

    case ProviderActionTypes.SearchFailPro:
      return {
        ...state,
        ProviderIds: [],
        loading: false
      };

    case ProviderActionTypes.SearchClearPro:
      return {
        ...state,
        ProviderIds: [],
        loading: false
      };

    case ProviderActionTypes.RemoveOneSuccess:
      return adapter.removeOne(action.id, state);

    // case ProviderActionTypes.ClearState:
    //   return INITIAL_STATE;

    default:
      return state;

    // case ProviderActionTypes.UpdateOne:
    //     return adapter.updateOne();
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const getState = createFeatureSelector<State>('providers');
export const selectProviders = (state: State) => state.Providers;
export const selectProviderIds = (state: State) => state.ProviderIds;
export const selectedSuppliers = (state: State) => state.Suppliers;

export const getSuppliers = createSelector(
  getState,
  selectedSuppliers
);

export const getFilteredProviders = createSelector(
  getState,
  selectProviders
);

export const getFilteredProviderIds = createSelector(
  getState,
  selectProviderIds
);

export const getRebates = createSelector(
  getState,
  (state: State) => state.rebates
)

export const getIsBusy = createSelector(
  getState,
  (state: State) => state.isBusy
);
